import { useState } from 'react';
import { ModifierGroup } from '../../types';
import { db } from '../../db';

interface SyncQueueItem {
  type: string;
  action: string;
  data: unknown;
  status: string;
  timestamp: number;
}

export function useModifierGroups(addToSyncQueue: (item: SyncQueueItem) => Promise<unknown>) {
  const [modifierGroups, setModifierGroups] = useState<ModifierGroup[]>([]);

  const addModifierGroup = async (item: ModifierGroup) => {
    const id = await db.modifierGroups.add(item);
    const newItem = { ...item, id: id as number };
    setModifierGroups(prev => [...prev, newItem]);
    await db.syncStack.add({ type: 'modifierGroup', action: 'create', data: newItem, status: 'pending', timestamp: Date.now() });
  };

  const updateModifierGroup = async (item: ModifierGroup) => {
    await db.modifierGroups.put(item);
    setModifierGroups(prev => prev.map(i => i.id === item.id ? item : i));
    await addToSyncQueue({ type: 'modifierGroup', action: 'update', data: item, status: 'pending', timestamp: Date.now() });
  };

  const deleteModifierGroup = async (id: number) => {
    await db.modifierGroups.delete(id);
    setModifierGroups(prev => prev.filter(i => i.id !== id));
    await db.syncStack.add({ type: 'modifierGroup', action: 'delete', data: { id }, status: 'pending', timestamp: Date.now() });
  };

  return {
    modifierGroups,
    setModifierGroups,
    addModifierGroup,
    updateModifierGroup,
    deleteModifierGroup,
  };
}
